import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from "@angular/core";
import {OnDestroy$} from "@pdtec/ngx-observable-lifecycle";
import {Subject} from "rxjs";

@Component({
  selector: 'app-filter-pills-skeleton',
  templateUrl: './filter-pills-skeleton.component.html',
  styleUrls: ['./filter-pills-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class FilterPillsSkeletonComponent extends OnDestroy$ implements OnInit, OnDestroy{
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
